import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import qs from "qs";
import { queryLimitPackageDetail } from "utils/api";
import "./style.scss";
import { matchRoutes } from 'react-router-config';
import routes from 'routes';
import Utils from 'utils/utils.js';

export default function SchemeDetail() {
  const location = useLocation();
  const [detailData, setDetailData] = useState({});

  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  let matchedRoutes = matchRoutes(routes, location.pathname);
  matchedRoutes = matchedRoutes.filter(matchRoute => matchRoute.route.breadcrumbName);
  matchedRoutes[0].route.breadcrumbName = query.authPackName

  useEffect(() => {
    queryLimitPackageDetail({
      appKey: query.appKey,
      authId: query.authId,
      articleId: query.articleId,
    }).then((res) => {
      if (res.data.success) {

        if(Utils.getQueryVariable('k')){
          res.data.result.articleName = Utils.matchSearchKeys(res.data.result.articleName,'str',false)
          res.data.result.bigContent = Utils.matchSearchKeys(res.data.result.bigContent,'str')
         }

        setDetailData(res.data.result);


        matchedRoutes[0].route.breadcrumbName = query.authPackName+res.data.result.articleName

      }
    });
  }, [query.appKey, query.authId]);

  return (
    <div className="scheme_detail">
      <div className="scheme_top">
        <span className="title"  dangerouslySetInnerHTML={{ __html: `${query.authPackName}${detailData.articleName}` }}></span>
        <span className="time">最后更新时间{detailData.updateTime}</span>
      </div>
      <div
        className="scheme_content __html"
        dangerouslySetInnerHTML={{ __html: detailData.bigContent }}
      ></div>
    </div>
  );
}
